import { TableDetailForOrder } from './table';

export enum TypeSplitTable {
	open = "open",
	transfer = "transfer"
}
export interface SplitTableData {
	type: TypeSplitTable;
	table: TableDetailForOrder
}

export interface VirtualTable {
	id: number;
	tableAlias: string;
	ticketId?: number;
	status?: string;
	ownerName?: string;
	createdAt?: string;
	color?: string;
	hasTicket?: boolean;
	numberOfGuests?: number;
}
